// extracted by mini-css-extract-plugin
module.exports = {"container":"panel-style-module__container___3oYDk","heading":"panel-style-module__heading___Cmujm","content":"panel-style-module__content___21B6b"};